export default __webpack_public_path__ + "static/media/blank-ape.e2bfc18e.jpg";